import { wait } from "./wait";

const batchItUp = async <T = unknown>(params: {
    numberInBatch: number;
    maxRetries?: number;
    retryDelayInMs?: number;
    actions: (() => Promise<T>)[];
}): Promise<T[]> => {
    const { numberInBatch, actions } = params;
    const maxRetries = params.maxRetries ?? 0;
    const numberOfRuns = Math.ceil(actions.length / numberInBatch);
    const result: T[] = [];
    for (let index = 0; index < numberOfRuns; index++) {
        const start = index * numberInBatch;
        const end = start + numberInBatch;
        const batch = await Promise.all(
            actions.slice(start, end).map(async action => {
                let iteration = 0;
                do {
                    iteration += 1;
                    try {
                        const result = await action();
                        return result;
                    } catch (error) {
                        if (iteration >= maxRetries) {
                            throw error;
                        } else {
                            // eslint-disable-next-line no-console
                            console.warn(
                                `batch attempt failed, iteration: ${iteration} of ${maxRetries}`,
                            );
                            // eslint-disable-next-line no-console
                            console.warn(error);
                            await wait(params.retryDelayInMs ?? 100);
                        }
                    }
                } while (iteration < maxRetries);
                throw new Error(
                    `batch attempt failed to many times, tried ${maxRetries} times`,
                );
            }),
        );
        batch.forEach(item => result.push(item));
    }
    return result;
};

export { batchItUp };
